"use client";

import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BathroomCta() {
  return <section id="bathroomprojectctaband" data-nav="dark" className="relative overflow-hidden bg-secondary text-secondary-foreground py-20 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-secondary-foreground">
            Start Your Brookhaven Bathroom Remodel
          </h2>
          <p className="mt-4 text-base sm:text-lg text-secondary-foreground/80 leading-relaxed max-w-2xl mx-auto">
            Schedule an in-home design consultation to discuss your layout, materials, and comprehensive project scope.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 shadow-md transition-transform hover:-translate-y-0.5" asChild>
              <Link to="/ContactRequestAnEstimatePage">
                Get a Free Estimate
              </Link>
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/20 text-secondary-foreground bg-transparent hover:bg-secondary-foreground/10 hover:text-secondary-foreground shadow-xs transition-transform hover:-translate-y-0.5" asChild>
              <a href="tel:+14708479076" className="inline-flex items-center gap-2">
                <Phone className="size-4 shrink-0 text-primary" aria-hidden="true" />
                <span>Call (470) 847-9076</span>
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}